import { ENTITY_TYPES } from '@sales-center/common'
import { useSelectCustomFieldData } from '@user/store/customFields'
import { FormikHelpers } from 'formik'
import { ISaveServicesForLaterFormModel } from '../FormContents/typings'
import { formModelToInput } from '../mappers/formModelToInput'
import { useOpportunitySplit } from './useOpportunitySplit'
import * as React from 'react'
import { Id } from 'react-toastify'

type Props = {
  entityId: number
  entityType: ENTITY_TYPES
  onClose: () => void
  saveForLaterToastIdRef: React.MutableRefObject<Id | null>
}

export function useHandlers(props: Props) {
  const { entityId, entityType, onClose, saveForLaterToastIdRef } = props
  const { execute } = useOpportunitySplit({ saveForLaterToastIdRef })
  const { customFields } = useSelectCustomFieldData()

  function onSubmit(
    model: ISaveServicesForLaterFormModel,
    _formikHelpers: FormikHelpers<ISaveServicesForLaterFormModel>,
  ) {
    const input = formModelToInput(model, entityId, entityType, customFields)
    onClose()
    execute(input)
  }

  return { onSubmit }
}
